import { ChangeEvent, DragEvent, useEffect, useState } from 'react';
import cn from 'classnames';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { files as fileHelpers, FilesNamespace } from '@/shared/helpers';
import { BFC } from '@/shared/types';

type DropzoneProps = {
  onAddFiles: (files: File[]) => void;
  acceptFiles: FilesNamespace;
};

export const Dropzone: BFC<DropzoneProps> = ({ onAddFiles, children, acceptFiles }) => {
  const [dragover, setDragover] = useState(false);
  const inputAccept = fileHelpers.getFileInputAccept(acceptFiles);

  const onChange = (ev: ChangeEvent) => {
    const target = ev.target as HTMLInputElement | undefined;
    if (target?.files) {
      onAddFiles(Array.from(target.files));
    }
  };

  const onDragOver = (ev: DragEvent) => {
    ev.preventDefault();
    setDragover(true);
    console.log('0 onDragOver', ev);
  };
  const onDragLeave = () => {
    setDragover(false);
    console.log('1 onDragLeave');
  };

  const onDrop = (ev: DragEvent) => {
    ev.preventDefault();
    const files = ev.dataTransfer.files;
    onAddFiles(Array.from(files));
  };

  useEffect(() => {
    const prevent = (ev: Event) => ev.preventDefault();

    window.addEventListener('dragover', prevent, false);
    window.addEventListener('drop', prevent, false);

    return () => {
      window.removeEventListener('dragover', prevent, false);
      window.removeEventListener('drop', prevent, false);
    };
  }, []);

  return (
    <label>
      <Container
        className={cn({ dragover: dragover })}
        onDragOver={onDragOver}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
      >
        <input
          style={{ display: 'none' }}
          type="file"
          multiple={true}
          accept={inputAccept}
          onChange={onChange}
        />
        {children}
      </Container>
    </label>
  );
};

const Container = styled.div`
  height: 160px;
  padding: 24px;
  border-radius: 8px;
  border: 1px dashed ${COLORS.systemDark100};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${COLORS.systemLight300};
  cursor: pointer;
  transition: background 300ms;

  &:hover {
    background: ${COLORS.systemLight200};
  }
  &.dragover {
    background: ${COLORS.systemLight200};
  }
`;
